import React, { Component, useRef } from "react";
import { Label, Input } from "reactstrap";
import { Link } from "react-router-dom";
import Configuration from "../../config/configuration";
import Axios from "axios";
import { MdDone } from "react-icons/md";
import "./CarImport.scss";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import ExploreProduct from "../Home/Products/Products";
import Makes from "./Makes/Makes";
import ModalPopup from "../Shared/ModalPopup/ModalPopup";
import CarInfoModal from "../PostAd/SellCar/CarInfoModal/CarInfoModal";
import Select from "react-select";
import { data } from "../../assets/data/index";
import MaskConfig from "../../config/maskConfig";
import InputMask from "react-input-mask";
import CommonService from "../../services/common-service";
import UserService from "../../services/user-service";
import MobileCarInfoModal from "../PostAd/SellCar/MobileCarInfoModal/MobileCarInfoModal";
import FormsService from "../../services/FormsService";
import LocalStoreService from "../../services/localStore-service";
import AdsService from "../../services/ads-service";
import InfoService from "../../services/info-service";
import PopularNewCars from "../NewCars/New/Listing/Popular";
import VideoHomePage from "../NewCars/New/VideoHomePage/VideoHomePage";
import NewsDiscussion from "../Home/News&Discussion/News&Discussion";
import CustomDuty from "../Home/CustomDuty/CustomDuty";
import trafficJamIcon from "../../assets/Images/traffic-jam.png";
import listIcon from "../../assets/Images/to-do-list.png";
import coinIcon from "../../assets/Images/coin.png";
import temperIcon from "../../assets/Images/elections.png";
import safetyIcon from "../../assets/Images/security.png";
import ageIcon from "../../assets/Images/age.png";
import steeringIcon from "../../assets/Images/steering-wheel.png";
import inspectionIcon from "../../assets/Images/car-inspection.png";
import shipmentIcon from "../../assets/Images/shipment.png";
import FAQs from "./FAQs";
import SlickSlider from "../SlickSlider/SlickSlider";
import { IconBase } from "react-icons";
import QueryFormWithoutPopup from "../Shared/QueryForm/QueryFormWithOutPopup";

const AuctionSheet = React.lazy(() =>
  import("../Home/AuctionSheet/AuctionSheet")
);

class Import extends Component {
  constructor(props) {
    super();
    this.localService = new LocalStoreService();
    this.adsService = new AdsService();
    this.infoService = new InfoService();
    this.maskConfig = new MaskConfig();
    this.commonService = new CommonService();
    this.userService = new UserService();
    this.formsService = new FormsService();
    this.apiURL = new Configuration().apiBaseUrl;
    this.state = {
      bodyTypes: [],
      makes: [],
      name: "",
      city: "",
      email: "",
      message: "",
      phoneNumber: "",
      type: "car-import",
      carInfo: "",
      showCarInfoModal: false,
      showMobileCarInfoModal: false,
      car: "",
      city: "",
      scrollTo: "",
      cities: [],
      makes: "",
      modelYear: "",
      modelYears: [],
      model: "",
      make: "",
      variant: "",
      makeId: 0,
      modelId: 0,
      variantId: 0,
      makes: [],
      models: [],
      variants: [],
      ToggleState: 3,
      tabClassName: "",
      errors: {
        carInfo: "",
        name: "",
        city: "",
        email: "",
        message: "",
        phoneNumber: "",
      },
    };
    this.aboutSection = React.createRef();
    this.querySection = React.createRef();
  }

  scrollDown = () => {
    window.scrollTo({
      top: this.aboutSection.current.offsetTop,
      behavior: "smooth",
    });
  };

  scrollDownToQuery = () => {
    window.scrollTo({
      top: this.querySection.current.offsetTop,
      behavior: "smooth",
    });
  };

  componentDidMount() {
    this.getYears();

  }

  resetForm = () => {
    this.setState({
      carInfo: "",
      car: "",
      name: "",
      city: "",
      email: "",
      message: "",
      phoneNumber: "",
    });
  };

  componentDidMount() {
    this.getYears();
    this.getCities();
    this.getActiveClass(3, "active show ")
    document.querySelector('video').play();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scrollTo !== this.props.scrollTo) {
      this.getYears();
      this.getCities();
      this.setState({
        scrollTo: this.props.scrollTo,
      });
    }
  }

  setFormData = () => {
    const {
      modelYear,
      model,
      make,
      variant,
      name,
      city,
      email,
      phoneNumber,
      message,
      carInfo,
      type,
    } = this.state;
    const formData = {
      modelYear,
      model,
      make,
      variant,
      name,
      city,
      email,
      phoneNumber,
      message,
      carInfo,
      type,
    };
    return formData;
  };

  submit = () => {
    let formData = this.setFormData();
    let { modelYear, make, model, variant } = { ...formData };
    const title1 = `${make ? make : ""} ${model ? model : ""} ${modelYear ? modelYear : ""
      } ${variant ? variant : ""}`;
    const title2 = `${modelYear ? modelYear : ""} ${make ? make : ""} ${model ? model : ""
      }  ${variant ? variant : ""}`;
    this.setState({
      car: title1,
      carInfo: title2,
    });
    formData.carInfo = title1;
    if (this.isValidForm(formData, this.state.errors)) {
      this.formsService
        .addFormsService(formData)
        .then((res) => {
          const { message, data } = res.data;
          if (message === "Query Form added successfully") {
            this.commonService.showToast(
              "Import Car form submitted successfully!",
              "success"
            );
            this.resetForm();
            this.setState({
              id: data ? data.id : 0,
            });
          } else {
            this.commonService.showToast(
              "Import Car form not submitted!",
              "error"
            );
          }
        })
        .catch((err) => {
          this.commonService.showToast("Something went wrong!", "error");
          this.userService.handleError(err);
        });
    } else {
      return;
    }
  };

  getCities() {
    let cities = [];
    data.pakCities.forEach((city) => {
      cities.push({ label: city.name, value: city.name });
    });
    this.setState({ cities });
  }

  toggleCarInfoModel = () => {
    this.setState({
      showCarInfoModal: !this.state.showCarInfoModal,
    });
  };

  toggleMobileCarInfoModel = () => {
    this.setState({
      showMobileCarInfoModal: !this.state.showMobileCarInfoModal,
    });
  };

  handleCarInfoModalClose = (carInfo) => {
    this.toggleCarInfoModel();
    this.setCarInfo(carInfo, "add");
    const { make, model, variant } = carInfo;
    this.setState({
      makeId: make.id,
      modelId: model.id,
      variantId: variant.id,
    });
  };

  handleMobileCarInfoModalClose = (carInfo) => {
    this.toggleMobileCarInfoModel();
    this.setCarInfo(carInfo, "add");
    const { make, model, variant } = carInfo;
    this.setState({
      makeId: make.id,
      modelId: model.id,
      variantId: variant.id,
    });
  };

  setCarInfo = ({ year, make, model, variant }, type) => {
    const info = `${year && year.value ? year.value : ""} ${make.name ? make.name : ""
      } ${model.name ? model.name : ""} ${variant && variant.name ? variant.name : ""
      }`;
    const title = `${make && make.name ? make.name : ""} ${model && model.name ? model.name : ""
      } ${year && year.value ? year.value : ""} ${variant && variant.name ? variant.name : ""
      }`;

    this.setState({
      car: title,
      modelYear: year ? year.value : "",
      carInfo: { year, make, model, variant },
    });

    if (variant && variant.car) {
      const { price } = variant.car;
      this.setState({
        carPrice: price,
      });
    }
  };

  isValidForm = (formData, errors) => {
    for (let key in formData) {
      this.checkFormErrors(key, formData[key]);
    }
    return this.commonService.checkFormValidity(this.state.errors);
  };

  checkFormErrors = (name, value) => {
    let errors = this.state.errors;
    switch (name) {
      case "modelYear":
        errors.modelYear = value === "" ? "Model Year is required!" : "";
        break;
      case "modelId":
        errors.model = value === "" ? "Model is requires!" : "";
        break;
      case "makesId":
        errors.makes = value === "" ? "Makes is requires!" : "";
        break;
      case "carInfo":
        errors.carInfo = value === "" ? "Car Info is required!" : "";
        break;
      case "name":
        errors.name = value === "" ? "Name is required!" : "";
        break;
      case "city":
        errors.city = value === "" ? "City is required!" : "";
        break;
      case "email":
        errors.email =
          value === ""
            ? "Email is required!"
            : this.commonService.isEmailValid(value)
              ? ""
              : "Email is not valid!";
        break;
      case "phoneNumber":
        errors.phoneNumber = !value
          ? "Phone number is required!"
          : value.length < 11
            ? "Invalid phone number!"
            : "";
      case "message":
        errors.message = value === "" ? "Message is required!" : "";
      default:
        break;
    }
    this.setState({ errors });
  };

  handleChange = (e, actionMeta) => {
    if (e.target) {
      const { value, name, type, checked } = e.target;
      this.checkFormErrors(name, value);
      this.setState({
        ...this.state,
        [name]: type === "checkbox" ? checked : value,
      });
    } else if (actionMeta && actionMeta.name) {
      const value = e.value;
      const { name } = actionMeta;
      this.checkFormErrors(name, value);
      this.setState({
        ...this.state,
        [name]: value,
      });
    }
  };
  getYears = () => {
    let year = [];
    for (let i = new Date().getFullYear(); i >= 1979; i--) {
      year.push({ label: i, value: i });
    }
    this.setState({ modelYears: year });
  };

  getAllMakes = (e) => {
    this.infoService.getAllMakes("car", e.value).then((res) => {
      const { data } = res;
      if (data && data.length) {
        this.setState({
          makes: data.map((x) => {
            return { label: x.name, value: x.id };
          }),
          modelYear: e.value,
        });
      }
    });
  };

  getModels = (e) => {
    this.infoService
      .getModelsByMakeIdAndMakeType(e.value, "car")
      .then((res) => {
        const { data } = res;
        if (data && data.length) {
          this.setState({
            models: data.map((x) => {
              return { label: x.name, value: x.id };
            }),
            make: e.label,
            makeId: e.value,
          });
        }
      });
  };

  toggleTab = (index) => {
    this.setState({ ToggleState: index });
  };
  getActiveClass = (index, className) => {
    this.setState({ ToggleState: this.state.ToggleState === index ? index : "", tabClassName: className });
  };

  getVariants = (e) => {
    const { modelYear } = this.state;
    this.infoService
      .getVariantsByModelIdAndYear(e.value, modelYear)
      .then((res) => {
        const { data } = res;
        if (data && data.variants.length) {
          this.setState({
            variants: data.variants.map((x) => {
              return { label: x.name, value: x.id };
            }),
            model: e.label,
            modelId: e.value,
          });
        }
      });
  };

  render() {
    const {
      city,
      cities,
      carInfo,
      car,
      showMobileCarInfoModal,
      showCarInfoModal,
      errors,
      name,
      email,
      phoneNumber,
      message,
      modelYears,
      modelYear,
      model,
      models,
      modelId,
      make,
      makes,
      makeId,
      variant,
      variantId,
      variants,
      ToggleState, tabClassName
    } = this.state;
    return (
      <div className="main">
        <BreadcrumbsItem to={`/car-import`}>Car Import</BreadcrumbsItem>
        <section className="headerDiv bg-lightgrey d-flex align-items-center">
          <div className="container">
            <div className="row align-items-center">
              <div className="headerText col-md-6 d-flex flex-column justify-content-center">
                <h1 className="mb-4 text-primary">
                  Import Japanese car in Pakistan
                </h1>
                <p className="text-left">
                  Pakistan's automobile sector is vast and blessed with a large number of international automakers, many of which are Japanese. If we discussed international automakers then we can see the UK, USA, and Japanese cars in our surroundings.
                </p>
                <p className="text-left">
                  Autodeals is a Pakistan-based automotive platform that helps clients from Japan, the United Kingdom, the United States of America, Canada, and other nations import their dream automobiles and motorbikes. In a year a large number of cars are imported from foreign countries.
                </p>
                <div className="importBtn mt-sm-4">
                  <button
                    className="adp-btn adp-btn-secondary"
                    onClick={this.scrollDownToQuery}
                  >
                    Import Your Dream Car
                  </button>
                </div>
              </div>
              <div className="headerImages col-md-6 d-flex flex-column align-items-md-end align-items-center mb-md-0 mb-3">
                <div class="bg-video">
                  <div class="blur-edges"></div>
                  <video class="bg-video__content" loop autoplay muted playsinline>
                    <source src="/images/banner-videos/import-your-car.mp4" type="video/mp4" />
                    <img src="/images/lexis.png" alt="Abstract Background" />
                  </video>
                </div>
                {/* <div className="img">
                  <img
                    loading="lazy"
                    src={require("../../assets/Images/lexis.png")}
                    alt="Import Your Dream Car"
                  />
                </div> */}
              </div>
            </div>
          </div>
        </section>

        {/* Please import component for popular cars here. This is the static htmls */}
        <section id="popular-new-cars" className="section-padding overflow-x-hidden">
          <div className="container only-popular-cars">
            <div
              className="d-flex align-items-center justify-content-center bg-lightgrey mb-5 rounded"
              style={{ height: "200px" }}
            >
              <img
                src="/images/banner-01-process.jpg"
                style={{ width: "100%" }}
              ></img>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="mb-0 align-self-center text-primary">
                Recently Imported <span className="text-capitalize">car</span>s
              </h2>
              <a className="adp-btn adp-btn-secondary" href="/new-cars/search/-/">
                View All
              </a>
            </div>

            {/* desktop section */}
            <div className="row popular-listing d-sm-flex d-none">
              <div className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a onClick={this.scrollDownToQuery}>
                      <img
                        className="card-img-top"
                        src="/images/popular-car-1.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Ranger Rover P400</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 5.00 Core to 6.00 Core</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a onClick={this.scrollDownToQuery}>
                      <img
                        className="card-img-top"
                        src="/images/popular-car-2.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Toyota Lexus LX 570</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 6.00 Core to 8.00 Core</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a onClick={this.scrollDownToQuery}>
                      <img
                        className="card-img-top"
                        src="/images/popular-car-3.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Land Cruiser ZX</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 6.00 Core to 8.00 Core</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a onClick={this.scrollDownToQuery}>
                      <img
                        className="card-img-top"
                        src="/images/popular-car-4.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Land Cruiser Prado</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 2.00 Core to 3.00 Core</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a onClick={this.scrollDownToQuery}>
                      <img
                        className="card-img-top"
                        src="/images/popular-car-5.jpg"
                        alt="toyota-aqua"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Honda Vezel</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 80.00 Lacs to 1.00 Core</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a onClick={this.scrollDownToQuery}>
                      <img
                        className="card-img-top"
                        src="/images/popular-car-6.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Toyota CHR</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 70.00 Lacs to 80.00 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a onClick={this.scrollDownToQuery}>
                      <img
                        className="card-img-top"
                        src="/images/popular-car-7.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Honda Insight</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 80.00 Lacs to 90.00 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a onClick={this.scrollDownToQuery}>
                      <img
                        className="card-img-top"
                        src="/images/popular-car-8.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Toyota Prius</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 65.00 Lacs to 75.00 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* mobile section */}
            <SlickSlider
              sliderSettings={{
                dots: false,
                infinite: true,
                arrows: false,
                speed: 1000,
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                slidesToScroll: 1,
              }}
              sliderClassName="popular-listing-slider d-sm-none d-block mt-4"
            >
              <div className="popular-listing-slider-slide">
                <div className="slide-inner mr-3">
                  <div className="border rounded-2 overflow-hidden">
                    <div className="popular-cars-img">
                      <a onClick={this.scrollDownToQuery} >
                        <img
                          className="card-img-top"
                          src="/images/popular-car-1.jpg"
                          alt="featured car"
                          style={{ objectFit: "contain" }}
                        />
                      </a>
                    </div>
                    <div className="popular-cars-details">
                      <h5>
                        <span className="card-title">Ranger Rover P400</span>
                      </h5>
                      <p className="popular-cars-price">
                        <span>PKR 5 Core to 6 Core</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popular-listing-slider-slide">
                <div className="slide-inner mr-3">
                  <div className="border rounded-2 overflow-hidden">
                    <div className="popular-cars-img">
                      <a onClick={this.scrollDownToQuery} >
                        <img
                          className="card-img-top"
                          src="/images/popular-car-2.jpg"
                          alt="featured car"
                          style={{ objectFit: "contain" }}
                        />
                      </a>
                    </div>
                    <div className="popular-cars-details">
                      <h5>
                        <span className="card-title">Toyota Lexus LX 570</span>
                      </h5>
                      <p className="popular-cars-price">
                        <span>PKR 6 Core to 8 Core</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popular-listing-slider-slide">
                <div className="slide-inner mr-3">
                  <div className="border rounded-2 overflow-hidden">
                    <div className="popular-cars-img">
                      <a onClick={this.scrollDownToQuery} >
                        <img
                          className="card-img-top"
                          src="/images/popular-car-3.jpg"
                          alt="featured car"
                          style={{ objectFit: "contain" }}
                        />
                      </a>
                    </div>
                    <div className="popular-cars-details">
                      <h5>
                        <span className="card-title">Land Cruiser ZX</span>
                      </h5>
                      <p className="popular-cars-price">
                        <span>PKR 6 Core to 8 Core</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popular-listing-slider-slide">
                <div className="slide-inner mr-3">
                  <div className="border rounded-2 overflow-hidden">
                    <div className="popular-cars-img">
                      <a onClick={this.scrollDownToQuery} >
                        <img
                          className="card-img-top"
                          src="/images/popular-car-4.jpg"
                          alt="featured car"
                          style={{ objectFit: "contain" }}
                        />
                      </a>
                    </div>
                    <div className="popular-cars-details">
                      <h5>
                        <span className="card-title">Land Cruiser Prado</span>
                      </h5>
                      <p className="popular-cars-price">
                        <span>PKR 2 Core to 3 Core</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popular-listing-slider-slide">
                <div className="slide-inner mr-3">
                  <div className="border rounded-2 overflow-hidden">
                    <div className="popular-cars-img">
                      <a onClick={this.scrollDownToQuery} >
                        <img
                          className="card-img-top"
                          src="/images/popular-car-5.jpg"
                          alt="featured car"
                          style={{ objectFit: "contain" }}
                        />
                      </a>
                    </div>
                    <div className="popular-cars-details">
                      <h5>
                        <span className="card-title">Honda Vezel</span>
                      </h5>
                      <p className="popular-cars-price">
                        <span>PKR 80.00 Lacs to 1 Core</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popular-listing-slider-slide">
                <div className="slide-inner mr-3">
                  <div className="border rounded-2 overflow-hidden">
                    <div className="popular-cars-img">
                      <a onClick={this.scrollDownToQuery} >
                        <img
                          className="card-img-top"
                          src="/images/popular-car-6.jpg"
                          alt="featured car"
                          style={{ objectFit: "contain" }}
                        />
                      </a>
                    </div>
                    <div className="popular-cars-details">
                      <h5>
                        <span className="card-title">Toyota CHR</span>
                      </h5>
                      <p className="popular-cars-price">
                        <span>PKR 70.00 Lacs to 80 Lacs</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popular-listing-slider-slide">
                <div className="slide-inner mr-3">
                  <div className="border rounded-2 overflow-hidden">
                    <div className="popular-cars-img">
                      <a onClick={this.scrollDownToQuery} >
                        <img
                          className="card-img-top"
                          src="/images/popular-car-7.jpg"
                          alt="featured car"
                          style={{ objectFit: "contain" }}
                        />
                      </a>
                    </div>
                    <div className="popular-cars-details">
                      <h5>
                        <span className="card-title">Honda Insight</span>
                      </h5>
                      <p className="popular-cars-price">
                        <span>PKR 80.00 Lacs to 90 Lacs</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popular-listing-slider-slide">
                <div className="slide-inner mr-3">
                  <div className="border rounded-2 overflow-hidden">
                    <div className="popular-cars-img">
                      <a onClick={this.scrollDownToQuery} >
                        <img
                          className="card-img-top"
                          src="/images/popular-car-8.jpg"
                          alt="featured car"
                          style={{ objectFit: "contain" }}
                        />
                      </a>
                    </div>
                    <div className="popular-cars-details">
                      <h5>
                        <span className="card-title">Toyota Prius</span>
                      </h5>
                      <p className="popular-cars-price">
                        <span>PKR 65.00 Lacs to 75.00 Lacs</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </SlickSlider>
          </div>
        </section>

        <section className="why-choose-auction-house-section section-padding bg-lightgrey">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h2 className="mb-4 text-primary">
                  Why Choose Autodeals?
                </h2>
                <p>Importing a car directly from worldwide is beneficial to your happiness, however under S.R.O 52 (1/) 2019, used car import is limited to overseas Pakistanis only.  As a member of all major auction houses in Japan. We can help you purchase vehicle directly from Japan and offer cost savings on direct import for car dealers or individuals.</p>
                <div className="vertical-row-container">
                  <div className="single-row">
                    <div className="inner1">
                      <div className="row-icon">
                        <img src={trafficJamIcon} alt="img" />
                      </div>
                    </div>
                    <div className="inner2">
                      <div>
                        <b>More Options: </b>Auction houses work through online services and upload approximately 145,000 inventories in the week. You may browse the inventory on websites and select your vehicle.
                      </div>
                    </div>
                  </div>
                  <div className="single-row">
                    <div className="inner1">
                      <div className="row-icon">
                        <img src={listIcon} alt="img" />
                      </div>
                    </div>
                    <div className="inner2">
                      <div>
                        <b>Transparency: </b>Autodeals will guide you properly with full of transparency and legal agreements. So, that you will know you invested your money at the right place. We will arrange the vehicle for you directly from Japan auction and will guide you about the import procedure. Because we convert our customers into friends.
                      </div>
                    </div>
                  </div>
                  <div className="single-row">
                    <div className="inner1">
                      <div className="row-icon">
                        <img src={coinIcon} alt="img" />
                      </div>
                    </div>
                    <div className="inner2">
                      <div>
                        <b>Low Budget Car: </b>Cars purchased directly from Autodeals are less expensive than those purchased from other exporters. Because other exporters maintain large margins and hide the actual price. They already store their inventory in the yard.
                      </div>
                    </div>
                  </div>
                  <div className="single-row">
                    <div className="inner1">
                      <div className="row-icon">
                        <img src={temperIcon} alt="img" />
                      </div>
                    </div>
                    <div className="inner2">
                      <div>
                        <b>No Tempering: </b>With our help, you can buy the exact car. Its exterior, interior, mileage, etc cannot be temper. Japanese experts make a report sheet before selling the car in an auction. This sheet is 100% reliable and no chance for tempering because worldwide cars are exported from Japan on behalf of this sheet.
                      </div>
                    </div>
                  </div>
                  <div className="single-row">
                    <div className="inner1">
                      <div className="row-icon">
                        <img src={safetyIcon} alt="img" />
                      </div>
                    </div>
                    <div className="inner2">
                      <div>
                        <b>Buyers Safety: </b>All the procedures are performed by us with the acknowledgment of the customer. We share all purchasing bills and invoices with customers. Because Japan's automobile trading sector is trustworthy, everyone participating in Japanese used car export is made accountable.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-md-0 mt-4">
                <div
                  className="border rounded d-flex flex-wrap align-items-center justify-content-center h-100 bg-white"
                  style={{ minHeight: 200 }}
                >
                  <img
                    src="/images/car-import-banners-2.jpg"
                    style={{ width: "100%" }}
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="auction-services-section section-padding">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="ad-tabs-box">
                  <div className="ad-tabs-nav-box">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item">
                        <a
                          className={ToggleState == 1 ? tabClassName + 'nav-link' : 'nav-link'}
                          id="quality-control-tab"
                          data-toggle="tab"
                          onClick={() => this.toggleTab(1)}
                          role="tab"
                          aria-controls="quality-control"
                          aria-selected="true"

                        >
                          Year of manufacturer
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          className={ToggleState == 2 ? tabClassName + 'nav-link' : 'nav-link'}
                          id="fast-shipping-tab"
                          data-toggle="tab"
                          onClick={() => this.toggleTab(2)}
                          role="tab"
                          aria-controls="fast-shipping"
                          aria-selected="false"

                        >
                          Bidding date
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          className={ToggleState == 3 ? tabClassName + 'nav-link' : 'nav-link'}
                          id="auction-guide-tab"
                          data-toggle="tab"
                          onClick={() => this.toggleTab(3)}
                          role="tab"
                          aria-controls="auction-guide"
                          aria-selected="false"

                        >
                          Import Duty
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="ad-tabs-content-box">
                  <div class="tab-content" id="myTabContent">
                    <div
                      className={ToggleState == 1 ? tabClassName + 'tab-pane fade' : 'tab-pane fade'}
                      id="quality-control"
                      role="tabpanel"
                      aria-labelledby="quality-control-tab"
                    >
                      <p>
                        The Year of a manufacturer is very important you must have to check before bidding. Because according to import policy if you will make a bid on the wrong car then it will be canceled and you will pay the fine.
                      </p>
                    </div>
                    <div
                      className={ToggleState == 2 ? tabClassName + 'tab-pane fade' : 'tab-pane fade'}
                      id="fast-shipping"
                      role="tabpanel"
                      aria-labelledby="fast-shipping-tab"
                    >
                      <p>You can place a bid on your selected car if the bidding date is valid. For the bidding date, you will check upcoming cars which are coming in auction houses. If you miss a bidding due date, you will be unable to purchase your selected vehicle. Then you can follow the same step the next day. </p>
                    </div>
                    <div
                      className={ToggleState == 3 ? tabClassName + 'tab-pane fade' : 'tab-pane fade'}
                      id="auction-guide"
                      role="tabpanel"
                      aria-labelledby="auction-guide-tab"
                    >
                      <p>The Pakistani government specifies the duty system for imported vehicles. When the car arrives at the port duties depend on three factors, year of manufacturer, Engine capacity (cc), Hybrid or normal. Hybrid vehicle duty is less than 50% of a normal car. The Pakistani government specifies the duty system for imported vehicles. When the car arrives at the port duties depend on three factors, year of manufacturer, Engine capacity (cc), Hybrid or normal. Hybrid vehicle duty is less than 50% of a normal car.</p>
                      <p>Commercial vehicles have different duties than normal units, which must be declared to the customs office.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-md-0 mt-3">
                <div className="h-100 border rounded p-3">
                  <h4 className="text-primary mb-3">Customer Reviews</h4>
                  <SlickSlider
                    sliderSettings={{
                      dots: false,
                      infinite: true,
                      arrows: true,
                      speed: 1000,
                      slidesToShow: 1,
                      autoplay: true,
                      autoplaySpeed: 5000,
                      slidesToScroll: 1,
                    }}
                    sliderClassName="client-reviews-slider"
                  >
                    <div className="client-reviews-slider-slide">
                      <div className="slide-inner">
                        <div className="review-card">
                          <div className="review-card-header">
                            <div className="reviewer-image-box">
                              <img
                                src="/images/review-1.jpeg"
                                alt="img"
                              />
                            </div>
                            <div className="reviewer-info-box">
                              <div className="top-row">
                                <div className="">Syed M Waseem</div>
                              </div>
                              <div className="rating-row">
                                <img
                                  style={{ height: "20px" }}
                                  src="data:image/png;base64,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"
                                  alt="img"
                                />
                              </div>

                            </div>
                          </div>
                          <div className="review-card-body">
                            <p>
                              Its always a good experience at Auto Deals car stop. I bought couple of cars from them and they never disappoint.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="client-reviews-slider-slide">
                      <div className="slide-inner">
                        <div className="review-card">
                          <div className="review-card-header">
                            <div className="reviewer-image-box">
                              <img
                                src="/images/review-2.jpeg"
                                alt="img"
                              />
                            </div>
                            <div className="reviewer-info-box">
                              <div className="top-row">
                                <div className="">Muhammad Ahmed</div>
                              </div>
                              <div className="rating-row">
                                <img
                                  style={{ height: "20px" }}
                                  src="data:image/png;base64,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"
                                  alt="img"
                                />
                              </div>

                            </div>
                          </div>
                          <div className="review-card-body">
                            <p>
                              Delivering the best service regarding Japanese cars. They won customer satisfaction with honesty, commitment, and fair guideline.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="client-reviews-slider-slide">
                      <div className="slide-inner">
                        <div className="review-card">
                          <div className="review-card-header">
                            <div className="reviewer-image-box">
                              <img
                                src="/images/review-3.jpeg"
                                alt="img"
                              />
                            </div>
                            <div className="reviewer-info-box">
                              <div className="top-row">
                                <div className="">Syed Hussain</div>
                              </div>
                              <div className="rating-row">
                                <img
                                  style={{ height: "20px" }}
                                  src="data:image/png;base64,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"
                                  alt="img"
                                />
                              </div>

                            </div>
                          </div>
                          <div className="review-card-body">
                            <p>
                              Proffessional staff and dealing and the thing that attracts me towards them is that there dealing is transparent each and every thing is crystal clear for customer.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SlickSlider>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="inquiry-section section-padding bg-lightgrey" ref={this.querySection}>
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <h2 className="text-primary">Inquire Online Now</h2>
                <div className="mb-4">
                  <p>
                    Reach out to us by filling out our contact form, and our sales team will promptly reach out to guide you through the custom clearance process. Trust our expertise for a hassle-free experience.
                  </p>
                </div>
                <QueryFormWithoutPopup modalClose={1} carInfo={car} type="car-import" />
              </div>
              <div className="col-md-5 mt-md-0 mt-5">
                <div
                  className="border rounded d-flex flex-wrap align-items-center justify-content-center h-100 bg-lightgrey2"
                  style={{ minHeight: 200 }}
                >
                  <img
                    src="/images/auction-sheet-banners.jpg"
                    style={{ width: "100%" }}
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-padding">
          <div className="container">
            <div className="max-w-md mx-auto">
              <h2 className="text-primary mb-3 text-center">How to Place Order</h2>
              <p className="text-center">If you are eligible to import a car in Pakistan. Autodeals will provide you complete services and will import a vehicle for you in Pakistan. The following is the procedure for selecting a car to import into Pakistan:</p>
              <div className="row">
                <div className="col-sm-6 mt-md-5 mt-4">
                  <div className="count-card">
                    <div className="count-card-header">
                      <div className="count">1</div>
                      <h4 className="count-card-title">Sign up for an account For free</h4>
                    </div>
                    <p>
                      Get sign up and register yourself with us for free. Fill out basic information then verify the email and sign in to your account. We will provide you access to monitor the auction procedures.
                    </p>
                  </div>
                </div>
                <div className="col-sm-6 mt-md-5 mt-4">
                  <div className="count-card">
                    <div className="count-card-header">
                      <div className="count">2</div>
                      <h4 className="count-card-title">
                        Initial Security Deposit
                      </h4>
                    </div>
                    <p>
                      After seeking the procedure if you take an interest and want to buy a car for you from Japan then you will submit an initial security deposit according to the vehicle. Then we will give you complete access to all auction houses. Then you can select the car for you and can bid on it.
                    </p>
                  </div>
                </div>
                <div className="col-sm-6 mt-md-5 mt-4">
                  <div className="count-card">
                    <div className="count-card-header">
                      <div className="count">3</div>
                      <h4 className="count-card-title">Make a budget</h4>
                    </div>
                    <p>
                      Check the estimated vehicle and determine the total expected cost.<br></br>
                      - Auction fees<br></br>- Cost & Freight Charges<br></br>- Custom Duty<br></br>- Registration fees in your country<br></br>After following all these instructions you can make a bid easily on your selected car.
                    </p>
                  </div>
                </div>
                <div className="col-sm-6 mt-md-5 mt-4">
                  <div className="count-card">
                    <div className="count-card-header">
                      <div className="count">4</div>
                      <h4 className="count-card-title">Search Car</h4>
                    </div>
                    <p>
                      Choose from Honda, Toyota, Mazda, Suzuki, Lexus, Daihatsu and much more options to explore. We give direct access to live auctions you can find your dream car from our inventory and auctions. Pay online with few easy steps or reserve your dream car.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="regulations-section section-padding bg-lightgrey">
          <div className="container">
            <div className="max-w-md mx-auto">
              <h2 className="mb-5 text-center text-primary">
                Car Import Process in Pakistan from Japan{" "}
              </h2>
              <div className="regulation-card">
                <div className="card-icon-box">
                  <img src={ageIcon} alt="img" />
                </div>
                <div className="card-description-box">
                  <h4>Import policy of Pakistan</h4>
                  <div className="card-description">
                    <p>
                      Suppose you want to import cars in Pakistan from other countries. Sedans, Hatchbacks these cars can import for no more than 3 years, and commercial, and station wagons cannot import for more than 5 years.
                    </p>
                  </div>
                </div>
              </div>
              <div className="regulation-card">
                <div className="card-icon-box">
                  <img src={steeringIcon} alt="img" />
                </div>
                <div className="card-description-box">
                  <h4>Right Hand Drive</h4>
                  <div className="card-description">
                    <p>
                      In Pakistan the majority of car users use only right hand drive car in Pakistan. Rarely you can see left hand drive.
                    </p>
                  </div>
                </div>
              </div>
              <div className="regulation-card">
                <div className="card-icon-box">
                  <img src={inspectionIcon} alt="img" />
                </div>
                <div className="card-description-box">
                  <h4>Inspection</h4>
                  <div className="card-description">
                    <p>No inspection on imported cars</p>
                  </div>
                </div>
              </div>
              <div className="regulation-card">
                <div className="card-icon-box">
                  <img src={shipmentIcon} alt="img" />
                </div>
                <div className="card-description-box">
                  <h4>Shipment Duration</h4>
                  <div className="card-description">
                    <p>Shipment (RORO) duration from Japan to Pakistan is approximately 40 to 45 days.</p>
                  </div>
                </div>
              </div>
              <div className="regulation-card">
                <div className="card-icon-box">
                  <img src={listIcon} alt="img" />
                </div>
                <div className="card-description-box">
                  <h4>Required Documents</h4>
                  <div className="card-description">
                    <ul className="no-list-style">
                      <li>Original B/L (Bill of Lading) </li>
                      <li>Export certificate</li>
                      <li>And invoice of the car purchased.</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="regulation-card">
                <div className="card-icon-box">
                  <img src={listIcon} alt="img" />
                </div>
                <div className="card-description-box">
                  <h4>At Your Door Step</h4>
                  <div className="card-description">
                    <p>After clearance, the duty tax car will send by car courier to the buyer's location. All documents include the original B/L (Bill of Lading), Export certificate, and invoice of the car purchased courier to the customer at his door step.</p>
                    <p>The buyer can receive his dream car and enjoy his ride.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <div className="container">
          <div className="pakistan row d-flex justify-content-between">
            <div className="col-sm-6">
              <div className="text d-flex flex-column justify-content-center">
                <h1>Cars Import in Pakistan</h1>
                <p>
                  <a href="https://autodeals.pk">Autodeals.pk</a> is a Pakistan based automotive platform that provides the services to import dream cars & bikes for clients from Japan, U.K, U.S.A, Canada, and many more countries. We have also extended cars export to the other countries as well.</p>
                <p>The experience of 11 years of provide services has proved to be leading the best online destination that helps every individual car seller & buyer to affiliate every turn of car ownership. This is a place that helps you to transform your dream car into reality. Now importing a car is just one step away.</p>
                <div className="pakBtn">
                  <button onClick={this.scrollDown}>Import Car</button>
                </div>
              </div>
            </div>
            <div className="col-sm-5">
              <div className="pakImg ">
                <div className="card imageDiv"></div>
                <div className="">
                  <img loading="lazy" src={require("../../assets/Images/carImport/Image_245.png")} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* <div className="importForm pb-5" id="import" ref={this.aboutSection}>
          <div className="first container ">
            <h3>Import Car</h3>
            <p>(All Fields with * are mandatory)</p>
            <div className="row">
              <div className="inputs1 col-sm-6">
                <div className="d-flex ">
                  <Label For="car" className="mt-2 col-sm-2 col-3">
                    CarInfo*
                  </Label>
                  <div className="carinfo1 col-sm-5 col-4 pr-1">
                    <div className="mb-4 relative">
                    <Select
                      ref={this.handleRef}
                      placeholder="Year"
                      options={modelYears}
                      value={modelYear ? { label: +modelYear, value: +modelYear } : ""}
                      name="modelYear"
                      onChange={(e) => this.getAllMakes(e)}
                    />
                    {errors.modelYear && <div className="invalid-feedback d-block">{errors.modelYear}</div>}
                    </div>
                    <div className="mb-4 relative">
                    <Select
                      ref={this.handleRef}
                      placeholder="Model"
                      name="modelId"
                      value={model ? { label: model.name ? model.name : model, value: +modelId } : ""}
                      options={models}
                      onChange={(e) => this.getVariants(e)}
                    />
                      {errors.model && <div className="invalid-feedback d-block">{errors.model}</div>}
                    </div>
                  </div>
                  <div className="carinfo2 col-sm-5 col-5 pl-1">
                    <div className="mb-4 relative">
                    <Select
                      ref={this.handleRef}
                      placeholder="Maker"
                      name="makeId"
                      value={make ? { label: make.name ? make.name : make, value: +makeId } : ""}
                      options={makes}
                      onChange={(e) => this.getModels(e)}
                    />
                    {errors.make && <div className="invalid-feedback d-block">{errors.make}</div>}
                    </div>
                    <div className="mb-4 relative">
                    <Select
                      ref={this.handleRef}
                      placeholder="Variant"
                      name="variantId"
                      value={variant ? { label: variant.name ? variant.name : variant, value: +variantId } : ""}
                      options={variants}
                      onChange={(e) =>
                        this.setState({
                          variantId: e.value,
                          variant: e.label,
                        })
                      }
                    />
                      {errors.variant && <div className="invalid-feedback d-block">{errors.variant}</div>}
                    </div>
                  </div>
                </div>
                <div className="d-flex mb-4">
                  <div className="col-sm-2 col-3">
                    <Label for="email" className="ml-2">
                      Email*
                    </Label>
                  </div>

                  <div className=" col-9 col-sm-10 mr-2">
                    <input type="text" className="form-control" name="email" placeholder="Email" value={email} onChange={this.handleChange} />
                    {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                  </div>
                </div>
                <div className="d-flex mb-4">
                  <div className="col-sm-2 col-3">
                    <Label for="phone" className="ml-2">
                      Phone*
                    </Label>
                  </div>
                  <div className=" col-9 col-sm-10 mr-2">
                    <InputMask
                      mask={this.maskConfig.phoneNumberMask}
                      maskChar={null}
                      className="form-control"
                      name="phoneNumber"
                      placeholder="03XXXXXXXXX"
                      value={phoneNumber}
                      onChange={this.handleChange}
                    />
                    {errors.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div>}
                  </div>
                </div>
              </div>
              <div className="inputs2 col-sm-6">
                <div className="d-flex mb-4">
                  <div className="col-sm-2 col-3">
                    <Label for="name" className="mt-2">
                      Name*
                    </Label>
                  </div>
                  <div className=" col-9 col-sm-10 mr-2">
                    <input type="text" className="form-control" name="name" placeholder="Name" value={name} onChange={this.handleChange} />
                    {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                  </div>
                </div>
                <div className="d-flex mb-4">
                  <div className="col-sm-2 col-3">
                    <Label for="city" className="mt-2">
                      City*
                    </Label>
                  </div>
                  <div className="col-9 col-sm-10 mr-2 ">
                    <Select options={cities} name="city"  placeholder="Select City" value={city ? { label: city, value: city } : ""} onChange={this.handleChange} />
                    {errors.city && <div className="invalid-feedback d-block">{errors.city}</div>}
                  </div>
                </div>
                <div className="d-flex mb-4">
                  <div className="col-sm-2 col-3">
                    <Label for="message" className="mt-2 mr-2">
                      Message*
                    </Label>
                  </div>
                  <div className="col-9 col-sm-10">
                    <textarea rows="4" className="form-control textarea-height" placeholder="Message..." name="message" value={message} onChange={this.handleChange}></textarea>
                    {errors.message && <div className="invalid-feedback d-block">{errors.message}</div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="importBtn d-flex justify-content-center my-5">
              <button type="button" className="ad-btn ad-btn-secondary " onClick={this.submit}>
                Submit
              </button>
            </div>
          </div>
        </div> */}
        {/* heading */}

        <section className="section-padding bg-lightgrey2">
          <div className="container pb-5">
            <div className="mb-5">
              <h2 className="text-center text-primary">
                Who Can Import A Car Into Pakistan?
              </h2>
              <p className="text-center">
                The S.R.O 52 (1) states that 2019 used automobile import in Pakistan is not for everyone. Under this S.R.O only overseas Pakistani can import the vehicle in Pakistan under the conditions.
              </p>
            </div>
            <div className="row cards">
              <div className="col-md-4 col-12 mb-2">
                <div class="card gift-scheme">
                  <h4 class="">Transfer of Residence</h4>
                  <p className="text-center mt-n1">Criteria List</p>
                  <div className="card-text text-center">
                    <h3>
                      <span className="days-color mr-1">700 days</span>
                      <span className="text-muted">outside Pakistan</span>
                    </h3>

                    <div className="text-left mx-4">
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Documents of purchased car
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">Passport or Pakistan Origin Card (POC) must be valid.</span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">National ID Card</span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Passport submission required
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Duty Transfer through Bank.
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          If pay the duty amount in your blood relation account then must require an FRC form.
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Visit to Pakistan must be required.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 mb-2">
                <div class="card gift-scheme">
                  <h4 class="text-center">Personal baggage</h4>
                  <p className="text-center mt-n1">Criteria list</p>
                  <div className="card-text text-center">
                    <h3>
                      <span className="days-color mr-1">180 days</span>
                      <span className="text-muted">outside Pakistan</span>
                    </h3>

                    <div className="text-left mx-4">
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Purchased car documents
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">Passport or Pakistan Origin Card (POC) must be valid.</span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">Duty Transfer through Bank.</span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          If pay the duty amount in your blood relation account then must require an FRC form.
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          National ID Card.
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Passport submission is required.
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Visit to Pakistan must be required.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 mb-2">
                <div class="card gift-scheme">
                  <h4 class="">Gift Scheme</h4>
                  <p className="text-center mt-n1">Criteria list</p>
                  <div className="card-text text-center">
                    <h3>
                      <span className="days-color mr-1">180 days</span>
                      <span className="text-muted">outside Pakistan</span>
                    </h3>

                    <div className="text-left mx-4">
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Documents of purchased car
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">Passport or Pakistan Origin Card (POC) must be valid.</span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">National ID Card</span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          If pay the duty amount in your blood relation account then must require an FRC form.
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Duty Transfer via Bank
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          Letters from the Embassy of Pakistan.
                        </span>
                      </p>
                      <p className="mb-1">
                        <span className="mr-1 done-color">
                          <MdDone />
                        </span>
                        <span className="done-text">
                          No need to visit Pakistan.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-center mt-4">The most popular cars used in Pakistan are Japanese. The Japanese automobile industry provides the biggest brands which are working as local manufacturers in Pakistan. </p>
            {/* <div className="importBtn text-center">
              <button className="btn" onClick={this.scrollDown}>Import Car</button>
            </div> */}
          </div>
        </section>

        <CustomDuty />

        <VideoHomePage />

        <NewsDiscussion />

        <FAQs bgClorClass="bg-lightgrey2" />

        <ExploreProduct />

        <AuctionSheet category={"car"} />

        {/* <div className="ceo">
          <div className="container">
            <div className="row">
              <div className="ceoMesasge col-sm-8">
                <h2>CEO Message</h2>
                <p>
                  I welcome you to our platform. Here you will come across all the concerns regarding the automobile industry, our company, services, and performance. Our company has flourished from a
                  small automobile dealing firm to a multi-line business group involving international automobile Imports/Exports and providing customs clearance solutions. From the selection of car
                  and color choice to the car buying and shipment, we put the effort into constructing a hassle-free outlook for our clients. I assure you, Our expert team will provide you one window
                  solution to your problems. I look forward to creating a continuous opportunity for our customers, in the near future.
                </p>
                <p>
                  In the end, I assure you that we will carry on delivering the utmost levels of our service in our firm as well as our showroom. Our core mission is to do our best to attain your
                  satisfaction. I would like to ask for your constant support for Autodeals and wishing you a safe and happy driving, may Allah bless you all
                </p>
              </div>
              <div className="ceoImage col-sm-4">
                <div className="mt-md-5">
                  <img loading="lazy" src={require("../../assets/Images/carImport/ceo.png")} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <ModalPopup
          isOpen={showCarInfoModal}
          onModalClose={this.toggleCarInfoModel}
          className="postyouradd-carinfo"
          backdrop={"static"}
        >
          {" "}
          <CarInfoModal
            category="car"
            onCarInfoClose={this.handleCarInfoModalClose}
            carInfo={carInfo}
          />{" "}
        </ModalPopup>
        <ModalPopup
          isOpen={showMobileCarInfoModal}
          onModalClose={this.toggleMobileCarInfoModel}
          className="postyouradd-carinfo"
          backdrop={"static"}
        >
          {" "}
          <MobileCarInfoModal
            category="car"
            onCarInfoClose={this.handleMobileCarInfoModalClose}
            carInfo={carInfo}
          />{" "}
        </ModalPopup>
      </div>
    );
  }
}

export default Import;
